import {getOrderStateTag} from "../view/myOrders/Overview";
import {Link} from "react-router-dom";
import {OrderItems} from "./OrderItems";
import {OrderAddressDisplay} from "../view/myOrders/OrderAddressDisplay";
import {germanDateTime, useChangeEffect} from "../js/util";
import {OrderShippingAndTotal} from "./OrderShippingAndTotal";
import {orderType, paymentOptions} from "../js/constants";
import {useState} from "react";
import {InputText} from "./form/InputText";
import {InputTextarea} from "./form/InputTextarea";
import {post} from "../js/api";
import {markDirty, showMessage} from "../js/main";

export const OrderInformation = ({order, referencingOrderInfo, showUser = false, adminView = false, updateOrderFunction = null, hideHeader = false, onItemAmountChange = null}) => {

    const [internalNote, setInternalNote] = useState(order.internalNote);

    const getWording = ()=>{
        return order.type == orderType.request ? "Anfrage" : "Bestell";
    }
    const getDescription = (paymentType) => {
        return paymentOptions.find(p => p.value == paymentType)?.label ?? '';
    }

    const getReferencingDescription = (referencingOrderInfo) => {
        if(referencingOrderInfo.type == "AUTH"){
            return "Genehmigt durch";
        }else if(referencingOrderInfo.type =="CUSTOMER"){
            return "QR-Bestellung";
        }
    }

    const saveNote = (text) => {
        post("/orders/"+order.id+"/updateOrderInternalNote", text).then(response => {
            markDirty()
            showMessage("Die Notiz wurde gespeichert.");
        });
    }

    useChangeEffect(() => {
        if (!internalNote) return;

        if(updateOrderFunction){
            const updated = {...order}
            updated.internalNote = internalNote;
            updateOrderFunction(updated);
        }

        const timeout = setTimeout(() => {
            saveNote(internalNote);
        }, 1000);

        return () => clearTimeout(timeout);
    }, [internalNote])


    return (
        <>
        {!hideHeader && <h2>{getWording()}informationen</h2>}
            <div className="default">
                <table className="mb-1">
                    <tbody>
                        <tr>
                            <td width="200"><strong>Status</strong></td>
                            <td><strong>{getOrderStateTag(order.state)}</strong></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>{getWording()}nummer</td>
                            <td>{order.id}</td>
                        </tr>
                        <tr>
                            <td>Datum</td>
                            <td>{germanDateTime(order.creationDate)}</td>
                        </tr>
                        <tr>
                            <td>Beschreibung</td>
                            <td>{order.summary}</td>
                        </tr>
                        <tr>
                            <td>E-Mail</td>
                            <td>{order.email}</td>
                        </tr>
                        {showUser && order.username && <tr>
                            <td>Bestellt von</td>
                            <td>
                                {adminView && <Link to={"/benutzer/edit/" + order.username}>{order.username}</Link>}
                                {!adminView && <>{order.username}</>}
                            </td>
                        </tr>}
                        {order.type != orderType.request &&
                            <tr>
                                <td>Bezahlart</td>
                                <td>{getDescription(order.paymentType)}</td>
                            </tr>
                        }
                        {order.internalOrderId &&
                            <tr>
                                <td>Interne Bestellnummer</td>
                                <td>{order.internalOrderId}</td>
                            </tr>
                        }
                        {referencingOrderInfo &&
                            <tr>
                                <td>{getReferencingDescription(referencingOrderInfo)}</td>
                                <td><Link to={"/bestellungen/bearbeiten/"+referencingOrderInfo.order}>{referencingOrderInfo.order}</Link></td>
                            </tr>
                        }
                        { showUser &&
                            <tr>
                                <td>Auftragsnummer:</td>
                                {!updateOrderFunction && <td>{order.lintnerReferenceNumber}</td>}
                                {updateOrderFunction && <td><InputText name={"lintnerReferenceNumber"} value={order.lintnerReferenceNumber} setter={v => {
                                    const updated = {...order}
                                    updated.lintnerReferenceNumber = v;
                                    updateOrderFunction(updated);
                                }} ></InputText></td>}
                            </tr>
                        }
                    </tbody>
                </table>
                {adminView && <InputTextarea name={"internalNote"} label="Interne Notiz" style={{height: "80%"}} setter={setInternalNote} value={internalNote}></InputTextarea>}
            </div>
            <OrderItems data={order} updateOrderFunction={updateOrderFunction} onItemAmountChange={onItemAmountChange}/>

            <OrderShippingAndTotal orderItems={order.items} shipping={order.shippingInfo} updateShippingFunction={updateOrderFunction ? (shipping) => {
                const newOrder = {...order};
                newOrder.shippingInfo = shipping;
                updateOrderFunction(newOrder);
            } : null}/>

            {order.billingAddress && <>
                <h2 className="mt-1d5 mb-03">{order.billingAddress.type === "BOTH" ? "Rechnungs- und Lieferadresse" : "Rechnungsadresse"}</h2>
                <OrderAddressDisplay address={order.billingAddress}/>

                {order.billingAddress.type !== "BOTH" &&
                    <>
                        <h2 className="mt-1d5 mb-03">Lieferadresse</h2>
                        <OrderAddressDisplay address={order.shippingAddress}/>
                    </>}
            </>}

        </>
    )
}
